import React, { useState } from 'react';
import { Smartphone, Globe, Tablet } from 'lucide-react';
import { Card, CardContent } from '../components/ui/card';
import { portfolio } from '../mock';

const Portfolio = () => {
  const [filter, setFilter] = useState('All');

  const categories = ['All', 'Mobile App', 'Mobile & Web App'];

  const filteredProjects = filter === 'All'
    ? portfolio
    : portfolio.filter(project => project.category === filter);

  const getCategoryIcon = (category) => {
    if (category.includes('Mobile') && category.includes('Web')) return Tablet;
    if (category.includes('Mobile')) return Smartphone;
    return Globe;
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <section className="pt-32 pb-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="text-center max-w-3xl mx-auto">
            <h1 className="text-5xl md:text-6xl font-bold text-black mb-6">
              Our Portfolio
            </h1>
            <p className="text-xl text-gray-600 leading-relaxed">
              Explore our successful FlutterFlow projects and see how we've helped businesses transform their ideas into reality
            </p>
          </div>
        </div>
      </section>

      {/* Filter Buttons */}
      <section className="pb-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-wrap justify-center gap-4">
            {categories.map((category) => (
              <button
                key={category}
                onClick={() => setFilter(category)}
                className={`px-6 py-2 rounded-full font-medium transition-all duration-300 ${filter === category
                    ? 'bg-black text-white'
                    : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
                  }`}
              >
                {category}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Projects Grid */}
      <section className="pb-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {filteredProjects.map((project) => {
              const IconComponent = getCategoryIcon(project.category);
              return (
                <Card
                  key={project.id}
                  onClick={() => {
                  if (project.applink) {
                    window.open(project.applink, "_blank", "noopener,noreferrer");
                  }
                }}
                  className="group hover:shadow-2xl transition-all duration-300 overflow-hidden border-2 border-gray-100 hover:border-black cursor-pointer"
                >
                  <div className="h-56 bg-gradient-to-br from-gray-100 to-gray-200 flex items-center justify-center relative overflow-hidden">
                    <div className="absolute inset-0 bg-black opacity-0 group-hover:opacity-10 transition-opacity duration-300"></div>
                    
                    <img
                      src={project.image}
                      alt={project.title}
                      className="max w-[100%] max h- [60%] object-contain"
                    />

                  </div>
                  <CardContent className="p-6">
                    <div className="inline-block px-3 py-1 bg-gray-100 text-black text-xs font-medium rounded-full mb-3">
                      {project.category}
                    </div>
                    <h3 className="text-xl font-bold text-black mb-2">{project.title}</h3>
                    <p className="text-gray-600 text-sm mb-4 leading-relaxed">{project.description}</p>
                  </CardContent>
                </Card>
              );
            })}
          </div>

          {filteredProjects.length === 0 && (
            <div className="text-center py-20">
              <p className="text-xl text-gray-600">No projects found in this category.</p>
            </div>
          )}
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 px-4 sm:px-6 lg:px-8 bg-gray-50">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-4xl md:text-5xl font-bold text-black mb-6">
            Want to See Your Project Here?
          </h2>
          <p className="text-xl text-gray-600 mb-8">
            Let's work together to create your next successful application
          </p>
          <a href="/contact">
            <button className="px-8 py-4 bg-black text-white rounded-lg hover:bg-gray-800 transition-all duration-300 hover:scale-105 font-medium">
              Start Your Project
            </button>
          </a>
        </div>
      </section>
    </div>
  );
};

export default Portfolio;
